import {Component, OnInit} from "@angular/core";
import {UserService} from "../../services/users.service";
import {Router} from "@angular/router";
import {Auth2Service} from "../../../../services/auth2.service";
import {LoggedInPageBaseComponent} from "../../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-successful-subscription-change',
  templateUrl: './successful-subscription-change.component.html',
  styleUrls: ['./successful-subscription-change.component.scss'],
  standalone: false
})
export class SuccessfulSubscriptionChangeComponent extends LoggedInPageBaseComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Subscription Changed Successfully'}
  ];

  showMessages = false;
  messages: any[] = [];
  username: string = '';

  pageName = 'Subscription Changed Successfully';
  changeSubscriptionDto: any = null;
  amountDueFormatted: string = "$0.00";
  endDate: Date = new Date();
  endDateStr: string = ''

  constructor(private userService: UserService,
              private routerChild: Router,
              private auth2ServiceChild: Auth2Service,
              private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy Succcessfully Changed Subscription");
  }

  ngOnInit() {
    this.pageErrorMessages = [];
    this.username = this.auth2ServiceChild.getUsername();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    // @ts-ignore
    let changeSubscriptionDtoStr = localStorage.getItem("changeSubscriptionDto")
    console.log("changeSubscriptionDto: " + changeSubscriptionDtoStr);
    if (changeSubscriptionDtoStr) {
      this.changeSubscriptionDto = JSON.parse(changeSubscriptionDtoStr)
      this.amountDueFormatted = this.changeSubscriptionDto['amountDueFormatted'];
      this.endDate = new Date(this.changeSubscriptionDto['endDate'])
      this.endDateStr = this.endDate.toLocaleDateString();
    }

    const counterFn = () => {
      this.routerChild.navigateByUrl('app/users/dashboard');
    }
    setTimeout(counterFn, 6000);
  }

  onGoToDashboard(): void {
    this.routerChild.navigateByUrl('app/users/dashboard');
  }
}
